import React from 'react';
import styles from './ProfilesBox.module.scss';
import { ProfileCard, ProfileCardProps } from 'new/elements/ProfileCard/ProfileCard';
import { BoxProps } from 'new/elements/Box/Box';
import { Typography } from '@mui/material';
import { Button } from 'new/elements/Button';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Stack } from 'new/elements/Stack';

interface ProfilesBoxProps {
  profiles: ProfileCardProps[];
  onClickProfile?: (profile: any) => void;
}

export function ProfilesBox(props: ProfilesBoxProps & BoxProps) {
  const onClick = (profile) => () => {
    props.onClickProfile(profile);
  };

  return (
    <div>
      <Stack direction="row" alignItems="center" marginLeft="32px">
        <Typography variant="subtitle1">{props.title}</Typography>
        <Button variant="text" endIcon={<ArrowForwardRounded />}>
          View All
        </Button>
      </Stack>
      <div className={styles.profiles_container}>
        {props.profiles.map((profile, idx) => (
          <ProfileCard
            onClick={!!props.onClickProfile ? onClick(profile) : undefined}
            key={profile.name + idx}
            {...profile}
          />
        ))}
      </div>
    </div>
  );
}
